import {Component, OnInit} from '@angular/core';
import { QueryParam } from '../shared/query-param';
import { ActivatedRoute, Params } from '@angular/router';
import { AlertService } from '../shared/alert.service';
import { HttpService } from '../shared/http.service';
import { InitjsService } from '../shared/initjs.service';
import { ConsultationResponse, ConsultationRequest } from '@builtbybros/al-model';
import moment = require('moment');

@Component({
  selector: 'app-consultation',
  templateUrl: './consultation.component.html',
  styleUrls: ['./consultation.component.scss']
})
export class ConsultationComponent implements OnInit {

  entity = 'consultation/';
  title = 'Consultas de la web';
  consultations = {};
  consultationsReady = false;
  actions = true;
  prevPath = '/consultation/';
  msg = {
    'changeStatus': 'Estado cambiado correctamente',
    'delete': 'Reserva borrada correctamente'
  };

  columns = [
    ['phone', 'Teléfono'],
    ['email', 'Email'],
    ['updatedAt', 'Fecha'],
    ['status', 'Status'],


  ];

  // [name, table header, isVisible]
  actionColumns = [
    ['highlight', 'Destacar', false],
    ['edit', 'Editar', false],
    ['delete', 'Eliminar', false],
    ['changeStatus', 'Cambiar Estado', true]
  ];

  states = [
    ['Pendiente', 'Pendiente'],
    ['Resuelto', 'Resuelto']
  ];

  hasDataTables = false;

  // getAllBooks filters
  pagination = 10;
  offset = 0;
  sort = 'id';
  status: string;
  orderByDate = '-updatedAt';

  constructor(private httpService: HttpService,
              private alertService: AlertService) {
  }

  ngOnInit() {
    this.getAllConsultations();
  }

  getAllConsultations() {
    const params = new Array<QueryParam>();
    params[0] = new QueryParam('pagination', this.pagination.toString());
    params[1] = new QueryParam('offset', this.offset.toString());
    params[2] = new QueryParam('sort', this.orderByDate);
    if (this.status){
      params[3] = new QueryParam('status', this.status);
    }
    this.httpService.getWithParams('/Consultation/All', params, ConsultationResponse.All)
      .subscribe(
        consultationsResponse => {
          this.consultations = consultationsResponse;
          for (const consultation of this.consultations['objects']) {
            consultation['updatedAt'] = moment(consultation['updatedAt']).format('DD/MM/YYYY HH:mm');
          }
          this.consultationsReady = true;
        },
        error => {
          this.alertService.error(error);
        }
      );
  }

  setState(val) {
    const consultation = new ConsultationRequest.Update();
    consultation.status = val[1];
    const responseExpected = new ConsultationResponse.Consultation();
    this.httpService.patch(val[0], '/Consultation/', consultation, responseExpected)
      .subscribe(
        consultationResponse => {
          this.alertService.success(this.msg['changeStatus']);
          this.getAllConsultations();
        },
        error => {
          this.alertService.error(error);
        }
      );
  }

  setLimit(value) {
    this.pagination = +value;
    this.getAllConsultations();
  }

  setOffset(value) {
    this.offset = +value;
    this.getAllConsultations();
  }

  filterStates(value) {
    this.status = (value === '0')? null : value;
    this.getAllConsultations();
  }


}



// WEBPACK FOOTER //
// ./src/app/consultation/consultation.component.ts